import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"18\" cy=\"6\" r=\"2.25\" stroke=\"#0F0F0F\" stroke-width=\"1.5\"></circle><circle cx=\"18\" cy=\"18\" r=\"2.25\" stroke=\"#0F0F0F\" stroke-width=\"1.5\"></circle><path fill=\"#0F0F0F\" fill-rule=\"evenodd\" d=\"m15.695 17.685-9-4 .61-1.37 9 4z\" clip-rule=\"evenodd\"></path><circle cx=\"5\" cy=\"12\" r=\"2.25\" stroke=\"#0F0F0F\" stroke-width=\"1.5\"></circle><path fill=\"#0F0F0F\" fill-rule=\"evenodd\" d=\"m16.305 7.685-9 4-.61-1.37 9-4z\" clip-rule=\"evenodd\"></path>", 5)
  ])))
}
export default { render: render }